import rumCustomEvents from '../services/events/rumCustomEvents';
import {showModal} from '../state/slice/modal';
import {dispatch} from '../state/store';
import useConnectionCheck from './useConnectionCheck';
import useNavigateReplace from './useNavigateReplace';

const useButtonClickHandler = ({
    onClick,
    route,
    modalType,
    rumActionName,
    isOnlineCheck = false,
    state,
    isClickTracked = true,
} = {}) => {
    const navigate = useNavigateReplace();

    const handler = (e) => {
        if (isClickTracked) {
            rumCustomEvents.recordActionClick({rumActionName});
        }

        if (onClick) {
            onClick(e);
        }
        if (route) {
            navigate(route, state && {state});
        }
        if (modalType) {
            dispatch(showModal({modalType}));
        }
    };

    return useConnectionCheck({action: handler, isOnlineCheck});
};

export default useButtonClickHandler;
